/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevPreferredDemandForecastDto
 */
export interface DevPreferredDemandForecastDto {
    /**
     * 
     * @type {number}
     * @memberof DevPreferredDemandForecastDto
     */
    year: number;
    /**
     * 
     * @type {string}
     * @memberof DevPreferredDemandForecastDto
     */
    quantityForecastVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevPreferredDemandForecastDto
     */
    discountForecastVersion: string | null;
}

/**
 * Check if a given object implements the DevPreferredDemandForecastDto interface.
 */
export function instanceOfDevPreferredDemandForecastDto(value: object): value is DevPreferredDemandForecastDto {
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('quantityForecastVersion' in value) || value['quantityForecastVersion'] === undefined) return false;
    if (!('discountForecastVersion' in value) || value['discountForecastVersion'] === undefined) return false;
    return true;
}

export function DevPreferredDemandForecastDtoFromJSON(json: any): DevPreferredDemandForecastDto {
    return DevPreferredDemandForecastDtoFromJSONTyped(json, false);
}

export function DevPreferredDemandForecastDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevPreferredDemandForecastDto {
    if (json == null) {
        return json;
    }
    return {
        
        'year': json['year'],
        'quantityForecastVersion': json['quantityForecastVersion'],
        'discountForecastVersion': json['discountForecastVersion'],
    };
}

export function DevPreferredDemandForecastDtoToJSON(json: any): DevPreferredDemandForecastDto {
    return DevPreferredDemandForecastDtoToJSONTyped(json, false);
}

export function DevPreferredDemandForecastDtoToJSONTyped(value?: DevPreferredDemandForecastDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'year': value['year'],
        'quantityForecastVersion': value['quantityForecastVersion'],
        'discountForecastVersion': value['discountForecastVersion'],
    };
}

